export default __webpack_public_path__ + "static/media/tileBg2.e16294ab.png";